import { render, staticRenderFns } from "./AdminVendas.vue?vue&type=template&id=65cf08d4&scoped=true"
import script from "./AdminVendas.vue?vue&type=script&lang=js"
export * from "./AdminVendas.vue?vue&type=script&lang=js"
import style0 from "./AdminVendas.vue?vue&type=style&index=0&id=65cf08d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf08d4",
  null
  
)

export default component.exports